import {  postSendEsignRequest } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_EsignRequestThunk = createAsyncThunk(
  "reKyc_EsignRequestThunk",
  async ({ params, token }) => {
    try {
      const response = postSendEsignRequest(params, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
